/** @format */

import React, { Component } from 'react';
import ClientMiniOverview from '../../Clients/ClientMiniOverview/ClientMiniOverview';
import SaleBoxes from '../SaleBoxes/SaleBoxes';
import SaleTable from '../SaleTable/SaleTable';
import SaleToolbar from './SaleToolbar/SaleToolbar';
import {
  Grid,
  Header,
  Container,
  Segment,
  Icon,
  Divider,
} from 'semantic-ui-react';

import { inject, observer } from 'mobx-react';

@inject('SalesStore', 'ClientsStore', 'SidebarStore')
@observer
class Sale extends Component {
  componentDidMount() {
    const { SalesStore } = this.props;
    SalesStore.loadCurrentSale(this.props.match.params.saleId);
  }

  renderManagedAlert() {
    const { SalesStore } = this.props;
    if (SalesStore.currentSale.data.status === 'new') {
      return 'Da posizionare in zona pick up';
    } else {
      return 'Già posizionata in zona pick up';
    }
  }

  render() {
    const { SalesStore } = this.props;
    const { address } = SalesStore.currentSale.data.shipping;
    return [
      <SaleToolbar key="saleToolbar" />,
      <Container className="content-container" key="saleContainer">
        <Grid>
          <Grid.Row>
            <Grid.Column tablet={16} computer={2} />
            <Grid.Column tablet={16} computer={12}>
              <Segment size="small">
                <ClientMiniOverview />
              </Segment>
              <SaleTable />
              <Segment size="small">
                <Header as="h3">
                  <small>
                    <Icon name="shipping fast" />
                  </small>
                  Spedizione({this.renderManagedAlert()})
                </Header>
                <Divider />
                {address ? (
                  <p>
                    <strong>Indirizzo:</strong>{' '}
                    {SalesStore.currentSale.data.shipping.address}
                  </p>
                ) : null}
                <SaleBoxes />
              </Segment>
            </Grid.Column>
            <Grid.Column tablet={16} computer={2} />
          </Grid.Row>
        </Grid>
      </Container>,
    ];
  }
}

export default Sale;
